import { useContext } from "react"
import { Field, useFormikContext } from "formik"

import { FormContext } from "../../context/formContext"
import { SelectButton } from 'primereact/selectbutton';
import styles from "../../styles/Form.module.css"

export default function TypeButtonSelector({ field, block, index }) {
  const isRequired = JSON.parse(field.field_validation.required[0])
  const form = useContext(FormContext)
  const isDisabled = form ? form.blocksSaved[block] : false
  const { values, setFieldValue } = useFormikContext()

  return (
    <div className={styles.field} style={{ order: index }}>
      <div className={styles.button_selector}>
        <div>
          <label className={styles.label}>
            {field.field_label}
            {isRequired && <span className={styles.asterisk}> *</span>}
          </label>
          {field.field_description && (
            <div className={styles.description}>{field.field_description}</div>
          )}
        </div>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => (
            <>
              <SelectButton
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={(e) => {
                  const newValue = e.value || values[formikField.name];
                  setFieldValue(formikField.name, newValue);
                }}
                style={{ minWidth: "104px" }}
                disabled={isDisabled}
                options={field.field_options}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
